import { gql } from 'graphql-request'

export const QueryBlockOffices = gql`
  fragment FragmentBlockOffices on BlockThreeColumnCardRecord {
          __typename
          id
          preface
          title
          offices {
            ...FragmentFeatureCardBlock
          }
          action {
            ...FragmentNavigationItem
          }
        }
`

export const BlockOffices = {
  __typename: 'BlockOffices',
  fragmentName: 'FragmentBlockOffices',
  fragmentQuery: QueryBlockOffices,
  fragments: ['FragmentNavigationItem']
}
